import React, { createContext, useContext, useMemo } from 'react';
const CountryCodeContext = /*#__PURE__*/createContext(undefined);
export const CountryCodeProvider = _ref => {
  let {
    children,
    countryCode
  } = _ref;
  const value = useMemo(() => ({
    countryCode
  }), [countryCode]);
  return /*#__PURE__*/React.createElement(CountryCodeContext.Provider, {
    value: value
  }, children);
};
export function useCountryCode() {
  const context = useContext(CountryCodeContext);
  return context == null ? void 0 : context.countryCode;
}
//# sourceMappingURL=country-code-context.js.map